import React from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const CustomerRef = ({ refNo, onRemoveRef }) => (
  <div className="customer-ref-no-div">{refNo}
    <GHref onClick={onRemoveRef} className="cursor-pointer ">
      <span className="ml-6">
        <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
      </span>
    </GHref>
  </div>
)

export default CustomerRef
